module.exports = __webpack_public_path__ + "img/zs_banner.086ffa37.png";